import './DynamicAppFlowsButton.css';
// Libraries
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import DOMPurify from 'dompurify';

// Components
import Tooltip from 'components/Tooltip/Tooltip';
import IconButton from 'components/Buttons/IconButton/IconButton';
import CardList from 'components/CardList/CardList';

//Assets
import { ReactComponent as ErrorIcon } from 'assets/icons/exclamation-triangle.svg';

const DynamicAppFlowsButton = ({ app, connection, flows, segmentId }) => {
    let navigate = useNavigate();
    const [showFlowsCardList, setShowFlowsCardList] = useState(false);
    const appName = app.name?.substr(0, 1).toUpperCase() + app.name?.substr(1, 1).toLowerCase();
    const logo = app.connection_dependencies?.find((e) => e.field === 'LOGO')?.value;
    const sanitizedLogo = logo ? DOMPurify.sanitize(logo, { USE_PROFILES: { svg: true } }) : null;
    const isActive = connection.status === 'active';

    return (
        <div className="dynamic-app-flows-btn">
            <IconButton
                onClick={() => {
                    // when in failed state, send to settings/connections page
                    if (connection.status === 'failed') {
                        return navigate('/settings/connections');
                    }
                    if (!isActive) return;

                    if (flows.length === 1) {
                        navigate(`/segmentation/flow/${flows[0].id}/${segmentId}`);
                    } else {
                        setShowFlowsCardList(true);
                    }
                }}
                padding="8px"
                className="app-logo-btn"
                tooltip={connection.name}
            >
                <div className="app-logo">
                    <div style={{ opacity: isActive ? 1 : 0.3 }}>
                        {sanitizedLogo ? (
                            <div
                                className="app-icon"
                                dangerouslySetInnerHTML={{ __html: sanitizedLogo }}
                            />
                        ) : (
                            appName
                        )}
                    </div>
                    {!isActive && (
                        <div className="app-logo-error">
                            <Tooltip tip="Connection is in a failed state">
                                <ErrorIcon fill="black" width="13px" height="13px" />
                            </Tooltip>
                        </div>
                    )}
                </div>
            </IconButton>
            {flows && flows.length > 1 && (
                <CardList
                    items={flows.map((flow) => ({
                        content: flow.name,
                        clickCallBack: () => {
                            navigate(`/segmentation/flow/${flow.id}/${segmentId}`);
                        },
                    }))}
                    onClickOutside={() => setShowFlowsCardList(false)}
                    getCardItemContent={(item) => item.content}
                    show={showFlowsCardList}
                    width="100px"
                    top="40px"
                    left="50%"
                    showDivider="all"
                    className="flows-card-list"
                />
            )}
        </div>
    );
};

export default DynamicAppFlowsButton;
